import Axios from "axios";
var UserService = (function () {
    function UserService() {
    }
    UserService.prototype.getUserListData = function (params) {
        return Axios.get("/supplierclientapi/account/list", { params: params });
    };
    UserService.prototype.addSave = function (params) {
        return Axios.post("/supplierclientapi/account/create", params);
    };
    UserService.prototype.editSave = function (params) {
        return Axios.post("/supplierclientapi/account/update", params);
    };
    UserService.prototype.getAuthTree = function (params) {
        return Axios.get("/supplierclientapi/supplierpower/list", { params: params });
    };
    UserService.prototype.getDataAuthTree = function (params) {
        return Axios.get("/supplierclientapi/supplierpower/data_list", { params: params });
    };
    UserService.prototype.getUserAuth = function (params) {
        return Axios.get("/supplierclientapi/supplier_role/power_list", { params: params });
    };
    UserService.prototype.getDepotAuthTree = function (params) {
        return Axios.get("/supplierclientapi/supplierpower/data_list", { params: params });
    };
    UserService.prototype.getUserDataAuth = function (params) {
        return Axios.get("/supplierclientapi/account/data_power_list", { params: params });
    };
    UserService.prototype.setUserAuth = function (params) {
        return Axios.post("/supplierclientapi/supplier_role/update_account_power", params);
    };
    UserService.prototype.setDataAuth = function (params) {
        return Axios.post("/supplierclientapi/account/power_update", params);
    };
    UserService.prototype.getAuthUserList = function (params) {
        return Axios.get("/supplierclientapi/account/children", { params: params });
    };
    UserService.prototype.transferAuth = function (params) {
        return Axios.get("/supplierclientapi/account/power_move", { params: params });
    };
    UserService.prototype.disEnable = function (params) {
        return Axios.post("/supplierclientapi/account/modify", params);
    };
    UserService.prototype.destoryAccount = function (params) {
        return Axios.post("/supplierclientapi/account/destroy", params);
    };
    UserService.prototype.getRecordList = function (params) {
        return Axios.get("/supplierclientapi/account/log", { params: params });
    };
    UserService.prototype.bindUsertoStore = function (params) {
        return Axios.post("/supplierclientapi/account_shop/bind_shop", params);
    };
    UserService.prototype.getbindedStore = function (params) {
        return Axios.get("/supplierclientapi/account_shop/shop_list", { params: params });
    };
    UserService.prototype.getRoleNameList = function (params) {
        return Axios.get("/supplierclientapi/supplier_role/get_options", { params: params });
    };
    UserService.prototype.getSupplierConfigdetail = function (params) {
        return Axios.post("supplierclientapi/supplier_config/detail", params);
    };
    UserService.createInstance = function () {
        UserService.getInstance();
    };
    UserService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return UserService;
}());
export default UserService;
